module.exports = __webpack_public_path__ + "static/offer-d-4-new-bd25ef6f2edefa0bb1ebedb6c13853a3.jpg";